export default __webpack_public_path__ + "static/media/3020.f113f273.jpg";